import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import AppLayout from "@/components/layout/AppLayout";

// Auth
import Login from "@/pages/auth/Login";
import Setup from "@/pages/Setup";
import LandingPage from "@/pages/LandingPage";

// Dashboard
import CompanyDashboard from "@/pages/company/CompanyDashboard";

// Documents
import DocumentList from "@/pages/documents/DocumentList";
import DocumentUpload from "@/pages/documents/DocumentUpload";
import DocumentReview from "@/pages/documents/DocumentReview";

// Schemas
import SchemaList from "@/pages/schemas/SchemaList";
import SchemaBuilder from "@/pages/schemas/SchemaBuilder";

// Admin
import AdminDashboard from "@/pages/superadmin/AdminDashboard";
import Companies from "@/pages/superadmin/Companies";
import AdminUsers from "@/pages/superadmin/AdminUsers";
import GlobalConfig from "@/pages/superadmin/GlobalConfig";

// Features
import Webhooks from "@/pages/webhooks/Webhooks";
import ApiKeys from "@/pages/apikeys/ApiKeys";
import DocumentRequests from "@/pages/requests/DocumentRequests";
import Analytics from "@/pages/analytics/Analytics";
import Profile from "@/pages/profile/Profile";
import PublicUpload from "@/pages/requests/PublicUpload";
import ApiPlayground from "@/pages/playground/ApiPlayground";
import PipelineList from "@/pages/pipelines/PipelineList";
import PipelineBuilder from "@/pages/pipelines/PipelineBuilder";
import CompanyReports from "@/pages/reports/CompanyReports";
import ApiDocs from "@/pages/developer/ApiDocs";
import CreditTopup from "@/pages/superadmin/CreditTopup";
import AlertSettings from "@/pages/alerts/AlertSettings";
import { AppConfigProvider } from "@/contexts/AppConfigContext";

import BulkProcessing from "@/pages/bulk/BulkProcessing";

import "@/index.css";

function App() {
  return (
    <AppConfigProvider>
      <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/r/:token" element={<PublicUpload />} />

          {/* Protected */}
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<CompanyDashboard />} />
            <Route path="/documents" element={<DocumentList />} />
            <Route path="/documents/upload" element={<DocumentUpload />} />
            <Route path="/documents/:id" element={<DocumentReview />} />
            <Route path="/schemas" element={<SchemaList />} />
            <Route path="/schemas/new" element={<SchemaBuilder />} />
            <Route path="/schemas/:id" element={<SchemaBuilder />} />
            <Route path="/webhooks" element={<Webhooks />} />
            <Route path="/api-keys" element={<ApiKeys />} />
            <Route path="/requests" element={<DocumentRequests />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/playground" element={<ApiPlayground />} />
            <Route path="/pipelines" element={<PipelineList />} />
            <Route path="/pipelines/new" element={<PipelineBuilder />} />
            <Route path="/pipelines/:id" element={<PipelineBuilder />} />
            <Route path="/reports" element={<CompanyReports />} />
            <Route path="/developer" element={<ApiDocs />} />
            <Route path="/admin/topup" element={<CreditTopup />} />
            <Route path="/alerts" element={<AlertSettings />} />
            <Route path="/bulk" element={<BulkProcessing />} />
            {/* Super Admin */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/companies" element={<Companies />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/config" element={<GlobalConfig />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </AppConfigProvider>
  );
}

export default App;
